import { MessageBar, MessageBarType } from '@fluentui/react';
import { useConst } from '@fluentui/react-hooks';
import React, { Fragment, useContext, useMemo } from 'react';
import ImmocomContext from '../../contexts/ImmocomContext';
import { useNotifications, useNotificationsManager } from '../../contexts/notificationContext';

const MessageBars = (props) => {

    // PROPS
    const { target } = props;

    // CONTEXTS
    const { dismissMessage, messages } = useContext(ImmocomContext); // Ancienne version, à supprimer une fois migrée
    const { errorMessages, infoMessages, successMessages, warningMessages } = useNotifications();
    const { dismiss } = useNotificationsManager();

    // CONST
    const { error, info, success, warning } = MessageBarType;

    const _styles = useConst({ dismissal: { color: "black" } });

    // MEMOS
    const _errorMessages = useMemo(() => errorMessages.filter(message => message.target === target), [errorMessages, target]);
    const _infoMessages = useMemo(() => infoMessages.filter(message => message.target === target), [infoMessages, target]);
    const _successMessages = useMemo(() => successMessages.filter(message => message.target === target), [successMessages, target]);
    const _warningMessages = useMemo(() => warningMessages.filter(message => message.target === target), [warningMessages, target]);

    // Lorsque la liaison avec ImmocomContext aura été supprimée alors on pourra supprimer ces memos
    // On travaillera directement avec les notifications récupérées via useNotifications
    const _oldErrorMessages = useMemo(() => messages.filter(message => message.type === "error"), [messages]);
    const _oldInfoMessages = useMemo(() => messages.filter(message => message.type === "info"), [messages]);
    const _oldSuccessMessages = useMemo(() => messages.filter(message => message.type === "success"), [messages]);
    const _oldWarningMessages = useMemo(() => messages.filter(message => message.type === "warning"), [messages]);

    // RENDER
    if ((messages.length + errorMessages.length + infoMessages.length + successMessages.length + warningMessages.length) <= 0) return null;
    else return <Fragment>

        {_oldErrorMessages.map(errorMessage => {
            const { id, message } = errorMessage;
            return <MessageBar key={id} isMultiline messageBarType={error} onDismiss={() => dismissMessage(id)} styles={_styles}>
                {message}
            </MessageBar>
        })}

        {_errorMessages.map(errorMessage => {
            const { id, message } = errorMessage;
            return <MessageBar key={id} isMultiline messageBarType={error} onDismiss={() => dismiss(id)} styles={_styles}>
                {message}
            </MessageBar>
        })}

        {_oldInfoMessages.map(infoMessage => {
            const { id, message } = infoMessage;
            return <MessageBar key={id} isMultiline messageBarType={info} onDismiss={() => dismissMessage(id)} styles={_styles}>
                {message}
            </MessageBar>
        })}

        {_infoMessages.map(infoMessage => {
            const { id, message } = infoMessage;
            return <MessageBar key={id} isMultiline messageBarType={info} onDismiss={() => dismiss(id)} styles={_styles}>
                {message}
            </MessageBar>
        })}

        {_oldSuccessMessages.map(successMessage => {
            const { id, message } = successMessage;
            return <MessageBar key={id} isMultiline messageBarType={success} onDismiss={() => dismissMessage(id)} styles={_styles}>
                {message}
            </MessageBar>
        })}

        {_successMessages.map(successMessage => {
            const { id, message } = successMessage;
            return <MessageBar key={id} isMultiline messageBarType={success} onDismiss={() => dismiss(id)} styles={_styles}>
                {message}
            </MessageBar>
        })}

        {_oldWarningMessages.map(warningMessage => {
            const { id, message } = warningMessage;
            return <MessageBar key={id} isMultiline messageBarType={warning} onDismiss={() => dismissMessage(id)} styles={_styles}>
                {message}
            </MessageBar>
        })}

        {_warningMessages.map(warningMessage => {
            const { id, message } = warningMessage;
            return <MessageBar key={id} isMultiline messageBarType={warning} onDismiss={() => dismiss(id)} styles={_styles}>
                {message}
            </MessageBar>
        })}

    </Fragment>;

};

export default MessageBars;